import { Button, Space, Typography } from "antd";
import styles from "./CookieBanner.module.scss";
import { setCookie, getCookie } from "cookies-next";
import { useState } from "react";
import useTranslation from "next-translate/useTranslation";
import Link from "next/link";
import { useIsClient } from "usehooks-ts";

const CookieBanner = () => {
  const isClient = useIsClient();
  const { t } = useTranslation("cookie-policy");
  const [consent, setConsent] = useState(() => getCookie("cookie_consent"));
  const oneYearFromNow = new Date();
  oneYearFromNow.setFullYear(oneYearFromNow.getFullYear() + 1);

  if (!isClient) return null;

  if (consent) return null;

  return (
    <div className={styles.CookieBanner}>
      <Typography.Title level={4} className={styles.Title}>
        {t("banner-title")}
      </Typography.Title>
      <Typography.Paragraph className={styles.Paragraph}>
        {t("banner-text")}
      </Typography.Paragraph>
      <Space>
        <Link passHref href="/cookie-policy" target="_blank">
          <Button type="primary">{t("banner-informativa")}</Button>
        </Link>
        <Button
          onClick={() => {
            setConsent(true);
            setCookie("cookie_consent", 1, {
              expires: oneYearFromNow,
            });
          }}
        >
          {t("banner-close")}
        </Button>
      </Space>
    </div>
  );
};

export default CookieBanner;
